import React from 'react';
import { Typography } from 'antd';
import { PhoneOutlined, SendOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface Props {
  phone: string | null;
  telegramContact: string | null;
  onPhoneCall: () => void;
  onTelegramUser: () => void;
}

interface ActionButtonProps {
  icon: React.ReactNode;
  label: string;
  iconColor: string;
  iconBg: string;
  onClick: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({ icon, label, iconColor, iconBg, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      flex: 1,
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
      padding: '12px 8px',
      minHeight: 44,
      background: 'var(--bl-surface)',
      border: '1px solid var(--bl-divider)',
      borderRadius: 'var(--bl-radius-lg)',
      cursor: 'pointer',
      fontFamily: 'inherit',
      WebkitTapHighlightColor: 'transparent',
    }}
  >
    <div style={{
      width: 38, height: 38, borderRadius: 'var(--bl-radius-sm)', flexShrink: 0,
      background: iconBg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 17, color: iconColor,
    }}>
      {icon}
    </div>
    <Typography.Text style={{ fontSize: 13, fontWeight: 600, color: 'var(--bl-text)', textAlign: 'center' }}>
      {label}
    </Typography.Text>
  </button>
);

export const ContactActionsCard: React.FC<Props> = ({ phone, telegramContact, onPhoneCall, onTelegramUser }) => {
  const { t } = useTranslation('customer');
  if (phone === null && telegramContact === null) return null;
  return (
    <div style={{ display: 'flex', gap: 10, margin: '10px 16px 0' }}>
      {phone !== null && (
        <ActionButton
          icon={<PhoneOutlined />}
          label={t('profile.contactActions.phoneShortLabel')}
          iconColor="rgba(31,139,76,1)"
          iconBg="rgba(31,139,76,0.10)"
          onClick={onPhoneCall}
        />
      )}
      {telegramContact !== null && (
        <ActionButton
          icon={<SendOutlined />}
          label={t('profile.contactActions.telegramShortLabel')}
          iconColor="var(--bl-primary)"
          iconBg="rgba(51,144,236,0.10)"
          onClick={onTelegramUser}
        />
      )}
    </div>
  );
};
